import { useCallback } from 'react';
import { useSnackbar } from 'utils/hooks/useSnackbar';
import { toUserMessage } from 'utils/apiErrorMessage';

// API エラーをトーストでユーザーに通知する安定コールバックを返す。
// useEffect 内の fetch(...).catch(notifyError) から直接渡せるよう、参照を安定させる
// （useSnackbar が安定参照を返すため useCallback の依存も安定）。
// ドロップダウン階層取得など、従来 .catch(console.error) で握りつぶしていた箇所の置換に使う。
export const useApiErrorNotifier = () => {
    const { showError } = useSnackbar();
    return useCallback(
        (error: unknown) => {
            console.error(error);
            showError(toUserMessage(error));
        },
        [showError],
    );
};
